export function ShowToast(
  message: string,
  type: "success" | "error" | "warning" | "info",
  timeout = 5000,
  onClose?: (toastId: string) => void
) {
  // Create toast container if it doesn't exist
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    toastContainer.className =
      "fixed top-4 left-1/2 transform -translate-x-1/2 z-50 space-y-2 w-full max-w-[90vw] flex flex-col items-center";
    document.getElementById("root")!.appendChild(toastContainer);
  }

  // Create the toast element
  const toastElement = document.createElement("div");
  const toastId = `toast-${Date.now()}-${Math.random()
    .toString(36)
    .substr(2, 9)}`;
  toastElement.id = toastId;

  // Set up the toast styling based on type
  const typeClasses = {
    success: "bg-SkaneGreen text-White",
    error: "bg-PrimaryRed text-White",
    warning: "bg-AudienceYellow1 text-White",
    info: "bg-AudienceGrey2 text-White",
  };

  toastElement.className = `toast rounded-lg p-4 w-full max-w-full max-h-full overflow-y-auto shadow-lg transform transition-all duration-300 ease-in-out ${typeClasses[type]}`;

  // Create the content
  toastElement.innerHTML = `
    <div class="flex items-center justify-between ${typeClasses[type]}">
      <p class="flex-1 mr-2">${message}</p>
      <button class="ml-2 text-current hover:opacity-70 transition-opacity " onclick="document.getElementById('${toastId}').remove()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  `;

  // Add the toast to the container
  toastContainer.appendChild(toastElement);

  // Animate in
  setTimeout(() => {
    toastElement.style.transform = "translateX(0)";
    toastElement.style.opacity = "1";
  }, 10);

  // Auto remove after timeout
  setTimeout(() => {
    if (toastElement.parentNode) {
      toastElement.style.transform = "translateX(100%)";
      toastElement.style.opacity = "0";
      setTimeout(() => {
        toastElement.remove();
      }, 300);
    }
    onClose?.(toastId);
  }, timeout);
}
